<template>
<div class="chapter">
<div class="inner_page">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="FMEP"><span aria-label=" Page xv. " epub:type="pagebreak" id="pg_xv" role="doc-pagebreak">A LONDON SOMETIN’ …</span></p>
<p class="FMEPC">TEK 9</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?31f57bfa